module.exports = __webpack_public_path__ + "img/mdsi-logo.df4868b3.svg";